import { render, staticRenderFns } from "./TrainingVideosEditor.vue?vue&type=template&id=6621b136&scoped=true&"
import script from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621b136",
  null
  
)

export default component.exports